import React from "react";
import SuperAdminOffsetSearch from "../components/pricing/SuperAdminOffsetSearch";
import InnerPage from "../components/InnerPage";

const SuperAdminOffsetSearchPage = () => {
  return (
    <InnerPage>
      <SuperAdminOffsetSearch />
    </InnerPage>
  );
};

export default SuperAdminOffsetSearchPage;
